import { useState, useEffect, useRef } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import ManageButtonArea from "./area/manage_btn";
import TodoListArea from "./area/todo_list";

function ViewTodoWordPrintArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    todo_pri_val_arr: [],
    is_only_fail_word: false,
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [todo_info_arr, set_todo_info_arr] = useState<any[]>([]);
  const [pre_data, set_pre_data] = useState<any>({
    stu_info: null,

    group_stu_info: null,
    group_stu_det_arr: null,
    group_stu_det_his_arr: null,

    stu_word_info_arr: null,
    stu_word_det_info_arr: null,
    stu_word_det_his_info_arr: null,
  });
  let saved_print_option: any = strFunc.get_storage("todo_word_print_option");
  if (saved_print_option) {
    saved_print_option = JSON.parse(saved_print_option);
  }
  const [print_options, set_print_options] = useState<any>({
    print_templete: "box",//line
    repeat_cnt: 10,//5,10
    user: user,
    box_opt: {
      row: 10,
      col: 5
    },
    line_opt: {
      row: 15,
    },
    is_print_stu_name: false,
    is_print_word: true,
    is_print_mean: true,
    is_reverse: false,
    ...saved_print_option
  });

  const printRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  useEffect(() => {
    get_todo_info_arr_by_ajax({
      todo_pri_val_arr: myProps.todo_pri_val_arr
    });
  }, []);

  const get_todo_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      "todo_pri_val_arr": myProps.todo_pri_val_arr,
      "is_reverse": print_options.is_reverse,
      ...inData
    };

    if (strFunc.is_empty(opt_obj.todo_pri_val_arr)) {
      return false;
    }

    let list_form_json = {
      "s_pri_arr": opt_obj.todo_pri_val_arr,
      "order_id": "a_reserve_start_date, a_seq",
      "is_paging": "",
      "s_addon_par_content": "1",
      "s_addon_comp_user": "1",
      "s_addon_mcomp_title": "1",
      s_addon_cg_word_custom: "1",
    };
    if (opt_obj.is_reverse) {
      list_form_json["order_id"] = "a_reserve_start_date DESC, a_seq";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/list', list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let todo_info = response.data["data"]["info_arr"][i];
            let tmp_cg_word_arr = [];
            let able_word_arr = [];
            let start_word_idx = strFunc.uncomma_int(todo_info["a_success_amount_start"]);
            let end_word_length = strFunc.uncomma_int(todo_info["a_success_amount"]);

            if (todo_info && todo_info.mtextbook_info
              && todo_info.mtextbook_info.study_arr
              && todo_info.mtextbook_info.study_arr.length > 0
              && todo_info.mtextbook_info.study_arr[0].cg_word_arr
            ) {
              tmp_cg_word_arr = todo_info.mtextbook_info.study_arr[0].cg_word_arr;
            }
            if (todo_info && todo_info.word_inside_info
              && todo_info.word_inside_info.cg_word_arr
              && todo_info.word_inside_info.cg_word_arr.length > 0
            ) {
              tmp_cg_word_arr = todo_info.word_inside_info.cg_word_arr;
            }

            if (tmp_cg_word_arr.length > 0) {
              for (let i = start_word_idx; i < start_word_idx + end_word_length; i++) {
                if (tmp_cg_word_arr[i]) {
                  able_word_arr.push(tmp_cg_word_arr[i]);
                }
              }
            }

            if (todo_info && todo_info["a_sort_det"] == "cg_word_custom" && todo_info.cg_word_custom_arr) {
              tmp_cg_word_arr = todo_info.cg_word_custom_arr;
              able_word_arr = todo_info.cg_word_custom_arr;
            }
            todo_info["able_word_arr"] = able_word_arr;
          }

          if (myProps.is_only_fail_word) {
            if (response.data["data"]["info_arr"].length > 0) {
              //오답은 한개건만 볼 수 있다.
              get_pre_data_by_ajax({
                todo_info: response.data["data"]["info_arr"][0],
                todo_info_arr: response.data["data"]["info_arr"],
              });
            }
          } else {
            set_todo_info_arr(response.data["data"]["info_arr"]);
          }
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          props.closePopup();
        }
      });
  };

  const get_pre_data_by_ajax = (inData: any) => {
    let opt_obj = {
      todo_info: null,
      todo_info_arr: [],
      ...inData
    };
    let todo_info = opt_obj.todo_info;
    let word_data_arr: any[] = [];
    if (todo_info.able_word_arr && todo_info.able_word_arr.length > 0) {
      for (let i = 0; i < todo_info.able_word_arr.length; i++) {
        let able_word_info = todo_info.able_word_arr[i];
        word_data_arr.push({
          uid: i + 1,
          cont_part: able_word_info.a_cont_part,
          e_script: able_word_info.a_word,
          k_script: able_word_info.a_mean,
          mp3_file: "",
          cont_class: able_word_info.a_cont_part == "word" ? "VOCA" : "4-skills",
          mp3_file_url: "",
        });
      }
    }

    let pre_s_start_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(), 'day', -21), "Y-m-d");
    let form_json_data = {
      stu_seq: todo_info.a_stu_mcomp_user_seq,
      coolen_study_par_id: "todo",
      coolen_study_par_seq: todo_info.row_pri_val,
      word_data_arr: word_data_arr,

      pre_s_start_date: pre_s_start_date,
      pre_s_end_date: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/save_study/get_study_data', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_pre_data(response.data["data"]);
          let tmp_pre_data = response.data["data"];
          let able_word_arr = todo_info.able_word_arr;

          todo_info.able_word_arr = [];
          for (let w_i = 0; w_i < able_word_arr.length; w_i++) {
            let word_info = able_word_arr[w_i];

            if (tmp_pre_data.stu_word_det_info_arr) {
              let is_fail_word = false;
              for (let i = 0; i < tmp_pre_data.stu_word_det_info_arr.length; i++) {
                let stu_word_det_info = tmp_pre_data.stu_word_det_info_arr[i];
                if (stu_word_det_info.a_word == word_info.a_word) {
                  if (stu_word_det_info.a_correct_cnt == 0) {
                    is_fail_word = true;
                  }
                }
              }
              if (is_fail_word) {
                todo_info.able_word_arr.push(word_info);
              }
            }
          }

          //오답 단어 필터링
          let change_todo_info_arr = [...opt_obj.todo_info_arr];
          if (change_todo_info_arr.length > 0) {
            change_todo_info_arr[0] = todo_info;
          }
          set_todo_info_arr(change_todo_info_arr);
        } else {
          alert("검색 중 오류." + response.data["msg"]);
          props.closePopup();
        }
      });
  };

  return (
    <div>
      <div className='text-center'>
        단어장 프린트 ({todo_info_arr.length}건)
      </div>
      <ManageButtonArea
        print_options={print_options}
        set_print_options={(inData: any) => {
          set_print_options(inData);
          let save_storage_json = {
            print_templete: inData.print_templete,
            repeat_cnt: inData.repeat_cnt,
            is_print_stu_name: inData.is_print_stu_name,
            is_print_word: inData.is_print_word,
            is_print_mean: inData.is_print_mean,
          };
          strFunc.set_storage("todo_word_print_option", JSON.stringify(save_storage_json));
        }}
        get_todo_info_arr_by_ajax={get_todo_info_arr_by_ajax}
        handlePrint={handlePrint}
      ></ManageButtonArea>
      <div ref={printRef} style={{ width: "21cm", margin: "0 auto" }} >
        <TodoListArea
          todo_info_arr={todo_info_arr}
          print_options={print_options}
          is_only_fail_word={myProps.is_only_fail_word}
        ></TodoListArea>
      </div>
    </div>
  );
};
export default ViewTodoWordPrintArea;